<template>
	<div class="root">
		<vipMeetingHeader/>
		<div class="container">
			<div class="tips">
				<p style="margin-top: 10px;"><span style="color:#B176C5;">限时取消：</span>截止预约日期前一天，可自主免费取消预约；超时限后不再接受取消，如未出席仍视为占用。</p>
				<p style="margin-top: 10px;"><span style="color:#B176C5;">注意事项：</span>如取消，该笔预约订单内所有预约时间段将一并取消，不支持部分取消。</p>
				<p style="margin-top: 10px;"><span style="color:#B176C5;">收费方式：</span>预约时即扣除5个回馈点数，如不足则无法预约成功。</p>
			</div>
			<div class="searchbar">
				<DatePicker size='large' v-model='beginTime' class='datepicker' type="date" placeholder="选择日期"></DatePicker>
				<div class="division">至</div>
				<DatePicker size='large' v-model='endiTime' class='datepicker' type="date" placeholder="选择日期"></DatePicker>
				<Button size='large' class='button' type='primary' @click='search' :loading='loading'>搜索</Button>
			</div>
			<Tabs v-model="roomStatus">
				<TabPane label="全部" name="all"></TabPane>
				<TabPane label="已预约" name="pay"></TabPane>
		        <TabPane label="已使用" name="used"></TabPane>
		        <TabPane label="已确认" name="complete"></TabPane>
		        <TabPane label="已取消" name="cancel"></TabPane>
		    </Tabs>
		    <div class='load' v-if='loading'>
				<loading />
			</div>
		    <template v-else-if='showOrders.length'>
		    	<div class="order" v-for='order in showOrders'>
					<div class="header">
						<div class="orderno">订单号:{{order.OrderNo}}</div>
						<div class="status">{{getOrderStatusStr(order.OrderStatus,order.PriceType)}}</div>
					</div>
					<div class="order-detail">
						<div class="room-img">
							<img :src="order.RoomImage" alt="">
						</div>
						<div class="rooms">

							<div class="desc" v-if='order.detail && order.detail[0]'>
								<div class='order-user'>
									<span>{{order.detail[0].BookUserName}}</span>
									<span>{{order.detail[0].MobilePhone}}</span>
								</div>
								<div class='order-user' v-if="order.detail[0].WithholdAccount">
									<span>代扣账号</span>
									<span>{{order.detail[0].WithholdAccount}}</span>
								</div>
								<div class='remark' v-if='order.detail[0].Description'>房间准备要求：{{order.detail[0].Description}}</div>
								<div class="store">{{order.detail[0].StoreName}}:</div>
							</div>
							<div class="room-item" v-for='detail in order.detail'>
								<div class="room-name">{{detail.RoomName || detail.ProductName}}<span v-if='!detail.IsRoom'>&nbsp;×&nbsp;{{detail.Qty}}</span></div>
								<div class="time" v-if='detail.IsRoom'>
									<div class="timerange">{{detail.BookingDate}} <span v-if='detail.BeginTime'>{{detail.BeginTime}} - {{detail.EndTime}}</span></div>
								</div>
								<div class="price">{{order.PriceType==1?'点数':'￥'}}{{detail.Price * (detail.Qty || 1)}}</div>
							</div>
						</div>
						<div class='detail-right'>
							<div class="amount">总计：<span>{{order.PriceType==1?'点数':'￥'}}{{order.Amount}}</span></div>
							<div class="buttons">
								<div class="cancel" @click='cancelOrder(order)' v-if='cancelable(order)'>取消</div>
								<div class="confirm" @click='goConfirm(order)' v-if='order.OrderStatus.toLowerCase() == "unpay"'>确认预约</div>
							</div>
						</div>
					</div>
				</div>
		    </template>
		    <div v-else class='nodata'>
		    	暂无数据
		    </div>
			
		</div>
	</div>
</template>

<script>
	import vipMeetingHeader from '@/components/header/vipMeetingHeader'
	import loading from "@/components/order/loading";
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import util from '@/config/util'
	const now = new Date()
	export default {
		data() {
			return {
				beginTime:new Date(now.getFullYear(),now.getMonth(),1),
				endiTime:new Date(now.getFullYear(),now.getMonth()+2,0),
				orders:[],
				loading:false,
				roomStatus:'all',
				cancelDay:1,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			vipMeetingHeader,
			loading,
		},
		computed: {
			...mapState({

			}),
			showOrders(){
				if (this.roomStatus == 'all') return this.orders
				return this.orders.filter(item=>item.OrderStatus.toLowerCase() == this.roomStatus)
			}
		},
		methods: {
			...mapActions([
				'getVIPReservationOrdersAction',
				'postVIPCancelReservationAction',
				'getVIPMeetingOrderTimeAction',
			]),
			async initData(){
				this.search()
				// 获取可提前取消的天数
				// let LifeVIP_012 = await this.getVIPMeetingOrderTimeAction({ParentCode: 'dt_lifevip_roomorder_time',Code: 'cancel'})
				// if(LifeVIP_012) this.cancelDay = Number(LifeVIP_012)
			},
			getOrderStatusStr(status,type){
				const statusStr = {
					unpay:type==1?'未支付':'未确认',
					cancel:'已取消',
					pay:type==1?'已支付':'已预约',
					complete:'已确认',
					used:'已使用'
				}
				return statusStr[status.toLowerCase()]
			},
			cancelable(order){
				let now = new Date()
				let nowDate = new Date(now.getFullYear(),now.getMonth(),now.getDate())
				// 截止活动前一天，都可以取消
				if (new Date.dateFrom(order.BookingDate) > nowDate && order.OrderStatus.toLowerCase() != 'cancel') {
					return true
				}
				return false
			},
			async search(){
				this.loading = true
				let response = await this.getVIPReservationOrdersAction({
					BeginTime:util.formatDate.format(this.beginTime,'yyyy-MM-dd'),
					EndTime:util.formatDate.format(this.endiTime,'yyyy-MM-dd'),
				})
				let ordersMap = {}
				response.forEach(item=>{
					if (ordersMap[item.ID]) {
						ordersMap[item.ID].detail.push(item)
					} else {
						ordersMap[item.ID] = item
						ordersMap[item.ID].detail = [item]
					}
				});
				let orders = Object.values(ordersMap)
				orders.sort((a,b)=>{return b.ID - a.ID})
				this.orders = orders
				this.loading = false
			},
			goHome(){
				this.$router.push('/vipmeeting/home')
			},
			goConfirm(order){
				this.$router.push(`/vipmeeting/confirm?code=${order?.ID}`)
			},
			async cancelOrder(order){
				this.$Modal.confirm({
					title:'确定要取消预约吗？',
					content:'温馨提示：如取消该笔预约，订单内所有预约时段将一并取消！',
					loading:true,
					onOk:async ()=>{
						let response = await this.postVIPCancelReservationAction({
							BookingId:order.ID,
						})
						this.$Modal.remove()
						setTimeout(()=>{
							if (typeof response.Value == 'string') {
								this.$Modal.info({
									title:'提示',
									content:response.Value
								})
								this.search()
							}
						}, 300)
						
					}
				})
				
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: #eee;
	}
	.container {
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
	}
	.searchbar {
		display:flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		margin-bottom: 30px;
		.datepicker {
			width:200px;
			border-radius: 60px;
			box-shadow: 3px 8px 20px 0px rgba(0,0,0,0.1);
		}
		.division {
			margin:0 20px;
		}
		.button {
			margin-left: 20px;
			width:150px;
			border-radius: 20px;
		}
	}
	.order {
		margin-bottom: 20px;
		.header {
			background-color: $theme-color;
			color:white;
			display:flex;
			justify-content: space-between;
			padding:10px 20px;
			@include fontSize($font-size-16);
			border-top-left-radius: 20px;
			border-top-right-radius: 20px;
		}
		.order-detail {
			background-color:white;
			display:flex;
			align-items: center;
			padding:20px;
			.room-img {
				width:150px;
				height:150px;
				img {
					border-radius: 20px;
					width:100%;
					height:100%;
					object-fit: cover;
				}
			}
			.rooms {
				flex:1;
				padding-left: 20px;
				@include fontSize($font-size-16);
				.desc {
					.store {
						margin-bottom: 10px;
					}
					.order-user {
						font-weight: bold;
						margin-bottom: 5px;
						span {
							padding-right: 20px;
						}
					}
					.remark {
						margin-bottom: 10px;
					}
				}
				.room-item {
					margin-bottom: 10px;
					display:flex;
				}
				.room-name {
					font-weight: bold;
					margin-right: 20px;
				}
				.time {
					display:flex;
					.timerange {
						margin-right: 20px;
					}
				}
			}
			.detail-right {
				min-width: 140px;
			}
			.buttons {
				display:flex;
				align-self: flex-end;
				.cancel,.again,.confirm,.detail {
					cursor: pointer;
					@include fontSize($font-size-16);
					width:120px;
					color: $theme-color;
					border:1px solid $theme-color;
					text-align: center;
					border-radius: 20px;
					padding:5px 0;
					margin-right: 20px;
				}
			}
		}
	}
	.nodata {
		text-align: center;
		margin-top: 30px;
	}
	@media (max-width: 1450px){
		.order {
			.header {
				font-size: 14px;
			}
			.order-detail{
				.rooms {
					font-size: 14px;
				}
				.buttons {
					.cancel,.again,.confirm,.detail {
						font-size: 14px;
					}
				}
			}
		}
	}
	@media (max-width: 768px){
		.tips {
			margin:10px;
		}
		.container {
			padding-top: 2.4rem;
		}
		.searchbar {
			margin-top: 10px;
			margin-bottom: 20px;
			.datepicker {
				width:200px;
			}
			.division {
				margin:0 10px;
			}
			.button {
				margin-left: 10px;
			}
		}
		.order {
			.order-detail {
				position:relative;
				flex-wrap: wrap;
				padding:10px;
				.rooms {
					.room-item {
						flex-direction: column;
					}
				}
				.detail-right {
					flex-direction: column;
					display:flex;
					align-items: center;
					width:100vw;
					margin-top: 10px;
					.buttons {
						align-self:center;
						justify-content: center;
					}
				}
				
			}
		}
	}
	.price {
		color:red;
		font-weight: 500;
	}
	.amount {
		color:red;
		font-weight: 500;
		font-size: 18px;
		// @include fontSize($font-size-20);
		margin-bottom: 10px;
	}
</style>